module.exports = __webpack_public_path__ + "media/images/search-2e5a42b67203585d06c669540238ed4d.svg";